var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"money",class:_vm.size},[_c('span',{staticClass:"money-icon",style:(_vm.setColor)},[_vm._v("¥")]),_c('span',{staticClass:"money-text",style:(_vm.setColor)},[_vm._v(_vm._s(_vm._f("formatMoney")(_vm.money)))])])}
var staticRenderFns = []

export { render, staticRenderFns }